import gql from 'graphql-tag';

export const SearchAccidentIssue = gql`
  query SearchAccidentIssue($input: AccidentIssueWithCacheConnectionInput) {
    searchAccidentIssue {
      accidentIssueTableConnection(input: $input) {
        totalCount
        edges {
          node {
            accidentDatetime
            additionalDriverScheduled
            anyoneInjured
            canVehicleBeDriven
            createdAt
            createdBy
            damageToOtherVehicles
            deletedAt
            deletedBy
            description
            didDriverCallHelp
            dispatcherContactedManager
            dispatcherFirstName
            dispatcherId
            dispatcherLastName
            driverContactedManager
            driverFirstName
            driverId
            driverLastName
            driverEmployeeId
            id
            infoOfCrewMembers
            infoOfInjuredParties
            medicalNeeded
            outboundFlightNumber
            outboundFlightName
            outboundDatetime
            safetyFirstName
            safetyId
            safetyLastName
            safetyNotified
            samsaraCameraWorking
            specificLocation
            stationText
            thirdPartyInformation
            traceId
            tripFlightNumber
            tripLoopName
            tripId
            tripServicerIataAirlineCode
            tripScheduled
            typeOfMedicalAttention
            updatedAt
            updatedBy
            vehicleId
            vehicleTrackingId
            wasCeoCalled
            wasCrewInvolved
            wasDriverAtFault
            wasThirdPartyInvolved
          }
          cursor
        }
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
      }
    }
  }
`;
